import React from 'react';
import { default as Alert } from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import './StatusAlert.scss';

export type StatusAlertProps = {
  type: 'success' | 'error';
  title: string;
  messages: (string | React.ReactNode)[];
  className?: string;
};

const StatusAlert: React.FC<StatusAlertProps> = ({ type, title, messages, className = '' }) => {
  const variant = type === 'success' ? 'success' : 'danger';
  const icon = type === 'success' ? faCheckCircle : faExclamationCircle;
  const iconColorClass = type === 'success' ? 'text-success' : 'text-danger';
  const alertClasses = `status-alert status-alert-with-icon ${className}`.trim();

  return (
    <Alert className={alertClasses} variant={variant}>
      <div className="alert-icon">
        <FontAwesomeIcon icon={icon} className={iconColorClass} />
      </div>
      <div className="alert-content">
        <p className="alert-title fw-bold">
          {title}
        </p>
        {messages.map((message, index) => (
          <div
            key={index}
            className={`alert-body ${index === messages.length - 1 ? 'mb-0' : ''}`}
          >
            {message}
          </div>
        ))}
      </div>
    </Alert>
  );
};

export default StatusAlert;